import React from 'react';
import ActionButton from '../action-button';
import { MODES } from './constants';
import { useMatchXSBreakpoint } from '../../hooks';
const LivePreviewHeader = ({
  captions,
  logo,
  onBack,
  onToggleMode,
  primaryButton,
  selectedMode,
}) => {
  const isXs = useMatchXSBreakpoint();

  const modeButtonSize = isXs ? 'large' : 'medium';

  const handleToggleMode = (mode) => () => onToggleMode(mode);

  return (
    <div className="ws-ui-live-preview-header">
      <div className="ws-ui-live-preview-header__left">
        <ActionButton format="text" iconGlyph="back" onClick={onBack} label={captions.back} />
      </div>
      <div className="ws-ui-live-preview-header__center">
        <div className="ws-ui-live-preview-header__logo">
          {logo.src && (
            <img src={logo.src} width={logo.width} height={logo.height} alt={logo.alt} />
          )}
        </div>
      </div>
      <div className="ws-ui-live-preview-header__right">
        <div className="ws-ui-live-preview-header__mode-button">
          <ActionButton
            size={modeButtonSize}
            fontWeight="regular"
            format="solid-white"
            iconGlyph="desktop"
            rounded={false}
            onClick={handleToggleMode(MODES.desktop)}
            selected={selectedMode === MODES.desktop}
          />
        </div>
        <div className="ws-ui-live-preview-header__mode-button">
          <ActionButton
            size={modeButtonSize}
            fontWeight="regular"
            format="solid-white"
            iconGlyph="tablet"
            rounded={false}
            onClick={handleToggleMode(MODES.tablet)}
            selected={selectedMode === MODES.tablet}
          />
        </div>
        <div className="ws-ui-live-preview-header__mode-button">
          <ActionButton
            size={modeButtonSize}
            fontWeight="regular"
            format="solid-white"
            iconGlyph="smartphone"
            rounded={false}
            onClick={handleToggleMode(MODES.mobile)}
            selected={selectedMode === MODES.mobile}
          />
        </div>
        <div className="ws-ui-live-preview-header__use-template-button">{primaryButton}</div>
      </div>
    </div>
  );
};

export default LivePreviewHeader;
